import Customer from 'utils/Customer';
import Rudderstack from 'utils/Rudderstack';

const AccountController = class {
  static subscribeToLogout = () => {
    const $logoutButton = document.querySelectorAll('a.logout').item(0);

    $logoutButton.addEventListener('click', () => AccountController.clearUser());
  };

  static clearUser = () => {
    Customer.clearUser();
    Rudderstack.clearUser();
  };

  static init = () => {
    AccountController.subscribeToLogout();
  };
};

export default AccountController;
